import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const setFeatureFlagArm = {
  name: "setFeatureFlagArm" as const,
  input: z.object({
    teamId: zExt.objectId(),
    flagKey: createEnum(FeatureFlagKey),
    value: z.boolean(),
    environmentKey: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
